import axios from 'axios'
import store from './../store'

export default {
  install(Vue){
    Vue.prototype.$LoginService = {
      test(){
        //console.log('Funcionando');
      },
      async authorize(user,password){   
        var obj = {Username:user,Password:password,RememberMe:false}
        var response = await axios.post('api/auth/authorize/',obj);
        //console.log(response);

        if(response.data.Authenticated){
            store.dispatch("saveToken", {token: response.data.Token, expire: response.data.TokenExpires})
            store.dispatch("saveRefreshTokenEveryNMin",response.data.RefreshTokenEveryNMin*60*1000);
        }else{
            //console.log('Usuario o contraseña invalidos');
        } 
        return await response.data
      },
      async licencia(){
        var obj = {Username:'LoginXsite',Password:'ValidarLicenciaAbc123$%'}
        var response = await axios.post('api/auth/authorize/',obj);
        return await response.data;
      },
      async info(){
        var response = await axios.get('api/ubicacion/sysinfo');
        return await response.data;
      },
      async getUser(user){   
        var response = await axios.get('api/user/'+user);
        //console.log(response);

        return response.data;
      },
      getPermisos(PermisosUsuario){
        var permisos = {
          eventosAdm: false,
          alarmas: {},
          tickets: {},
          videos: {},
          mapas: {},
          mtto: {},
          registro: {},
        }

        permisos.tickets.acceso = false;
        permisos.tickets.insertar = false;
        permisos.tickets.modificar = false;
        permisos.videos.acceso = false;
        permisos.videos.insertar = false;
        permisos.videos.modificar = false;
        permisos.mapas.acceso = false;
        permisos.mapas.insertar = false;
        permisos.mapas.modificar = false;
        permisos.mtto.acceso = false;
        permisos.mtto.insertar = false;
        permisos.mtto.modificar = false;
        permisos.registro.acceso = false;
        permisos.registro.insertar = false;
        permisos.registro.listado = false;
        permisos.registro.transferir = false;
        permisos.registro.reporte = false;
        permisos.registro.enrolar = false;
        
        for (var i = 0; i < PermisosUsuario.length ; i++) {
          switch (PermisosUsuario[i].Panel) {
              case "TicketsMtto":
                  if (PermisosUsuario[i].acceso) {
                      permisos.mtto.acceso = true;
                  }
                  break;
              case "EventosAdm":
                  if (PermisosUsuario[i].acceso) {
                      permisos.eventosAdm = true;
                  }
                  break;
              case "registroAsistencia":
                  if (PermisosUsuario[i].acceso) {
                      permisos.registro.acceso = true;
                  }
                  if (PermisosUsuario[i].listado) {
                      permisos.registro.listado = true;
                  }
                  if (PermisosUsuario[i].transferir) {
                      permisos.registro.transferir = true;
                  }
                  if (PermisosUsuario[i].reporte) {
                      permisos.registro.reporte = true;
                  }
                  if (PermisosUsuario[i].enrolar) {
                      permisos.registro.enrolar = true;
                  }
                  if (PermisosUsuario[i].darbaja) {
                      permisos.registro.darbaja = true;
                  }
                  break;
              case "Alarmas":
                  if (PermisosUsuario[i].acceso) {
                      permisos.alarmas.acceso = true;
                  }
                  if (PermisosUsuario[i].insertar) {
                      permisos.alarmas.insertar = true;
                  }
                  if (PermisosUsuario[i].modificar) {
                      permisos.alarmas.modificar = true;
                  }
                  break;
              case "Tickets":
                  if (PermisosUsuario[i].acceso) {
                      permisos.tickets.acceso = true;
                  }
                  if (PermisosUsuario[i].insertar) {
                      permisos.tickets.insertar = true;
                  }
                  if (PermisosUsuario[i].modificar) {
                      permisos.tickets.modificar = true;
                  }
                  break;
              case "Mapas":
                  if (PermisosUsuario[i].acceso) {
                      permisos.mapas.acceso = true;
                  }
                  if (PermisosUsuario[i].insertar) {
                      permisos.mapas.insertar = true;
                  }
                  if (PermisosUsuario[i].modificar) {
                      permisos.mapas.modificar = true;
                  }
                  break;
              case "Videos":
                  if (PermisosUsuario[i].acceso) {
                      permisos.videos.acceso = true;
                  }
                  if (PermisosUsuario[i].insertar) {
                      permisos.videos.insertar = true;
                  }
                  if (PermisosUsuario[i].modificar) {
                      permisos.videos.modificar = true;
                  }
                  break;
          }
        }

        return permisos;
      }
    }
  }
}